import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function HomeIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M5 7.414l5-5 5 5V17h2V6.586l-7-7-7 7V17h2z" />
    </SvgIcon>
  );
}
